export default __webpack_public_path__ + "static/media/board-mockup.1e73a1be.png";